import Papa from 'papaparse';

const url: string[] = [
'https://gist.githubusercontent.com/hyenahyenatus/0c0813e214aa94444b42e61118a6d566/raw/3293e69488906e5a9b8396cbead16011d93ab934/yahoocategory01.csv',
'https://gist.githubusercontent.com/hyenahyenatus/dcd8f5a5e603e2694a5cd59ae2bfa0a4/raw/addf7fee03001fd72449f0847b48501ed7e236e9/yahoocategory02.csv',
'https://gist.githubusercontent.com/hyenahyenatus/28ef3f7cf82db9146c683c26ad93eda1/raw/896b7f94736bc855fd989840659fc34ab94bce8f/yahoocategory3.csv',
'https://gist.githubusercontent.com/hyenahyenatus/fc7e1b06678ee371554032ded0e323db/raw/33403f983cbf50610750fb78721252c5939650ab/yahoocategory4.csv',
'https://gist.githubusercontent.com/hyenahyenatus/09cd1fc11a3cf11e76016bf33455a81a/raw/466394938eb91aab40b025a6fcabae05e0f9f3ea/yahoocategory5.csv',
'https://gist.githubusercontent.com/hyenahyenatus/ede8f530dd22bbb533952a78f9371f2a/raw/eef48e7dc7e4712c906de420858da75ec7403dac/yahoocategory6.csv',
'https://gist.githubusercontent.com/hyenahyenatus/2b1957fb667496c380b2292f9dff5a15/raw/68326b3100c7f1b9bae918bf572c0309752e4520/yahoocategory7.csv',
];

// Use a cached approach to avoid fetching the data multiple times
let cachedCategories: CategoryYahoo[] | null = null;
// Cache for fast category lookup by value
let categoryLookupMap: Map<string, CategoryYahoo> | null = null;

// Export the promise so components can wait for categories to load
export const CATEGORIES_LOAD_PROMISE = fetchAndParseCSV(url);

async function fetchAndParseCSV(url: string[]): Promise<CategoryYahoo[]> {
  // If we already have the data cached, return it
  if (cachedCategories) {
    return cachedCategories;
  }
  
  try {
    let csvText = '';
    for (let i = 0; i < url.length; i++) {
      const response = await fetch(url[i]);
      csvText += await response.text();
    }
    
    const parsed = Papa.parse<CategoryYahoo>(csvText, {
      header: true,
      dynamicTyping: true,
    });
    
    // Cache the results
    cachedCategories = parsed.data;
    
    // Create lookup map for fast access
    categoryLookupMap = new Map();
    parsed.data.forEach(category => {
      if (category.value) {
        categoryLookupMap!.set(String(category.value), category);
      }
    });
    
    console.log(`📋 カテゴリデータ読み込み完了: ${parsed.data.length}件のカテゴリを Map に変換`);
    return parsed.data;
  } catch (error) {
    console.error("Error fetching Yahoo categories:", error);
    return [];
  }
}

export interface CategoryYahoo {
  value: string;
  label: string;
  path: string;
}

// Initialize categories asynchronously but don't block rendering
let categoriesPromise = fetchAndParseCSV(url);
export let CATEGORIESYAHOO: CategoryYahoo[] = [];

// Populate the array when data is available
categoriesPromise.then(data => {
  CATEGORIESYAHOO = data;
});

export interface Category {
  id: string;
  label: string;
  yahooId: number;
}

export const CATEGORIES: Category[] = [
  { id: 'toys', label: 'おもちゃ・ゲーム', yahooId: 26082 },
  { id: 'cd', label: 'CD', yahooId: 22240 },
  { id: 'dvd', label: 'DVD', yahooId: 22016 },
  { id: 'a-dvd', label: 'アダルトDVD', yahooId: 2084230642 },
  { id: 'a-other', label: 'アダルトその他', yahooId: 26174 },
  { id: 'blu-ray', label: 'ブルーレイ', yahooId: 2084249094 },
  { id: 'cassette', label: 'カセットテープ', yahooId: 22392 },
  { id: 'classic-cd', label: 'クラシックCD', yahooId: 2084006958 },
  { id: 'classic-dvd', label: 'クラシックDVD', yahooId: 2084049856 },
  { id: 'computer', label: 'コンピュータ', yahooId: 23564 },
  { id: 'electronics', label: '家電、AV、カメラ', yahooId: 23972 },
  { id: 'record', label: 'レコード', yahooId: 22308 }
];

export function getCategoryById(id: string): Category | undefined {
  return CATEGORIES.find(cat => cat.id === id);
}

export function getCategoryByYahooId(yahooId: number): Category | undefined {
  return CATEGORIES.find(cat => cat.yahooId === yahooId);
}

export function getCategoryLabel(id: string): string {
  return getCategoryById(id)?.label || '未設定';
}

export function getYahooId(id: string): number | undefined {
  return getCategoryById(id)?.yahooId;
}

export function getCategoryyahooByValue(value: string): CategoryYahoo | undefined {
  // Use the fast Map lookup if available, fallback to array search
  if (categoryLookupMap) {
    return categoryLookupMap.get(String(value));
  }
  
  // Fallback to array search if Map is not ready
  return CATEGORIESYAHOO.find(cat => String(cat.value) === String(value));
}

// Helper function to search Yahoo categories with optimized performance
export function searchYahooCategories(searchInput: string): CategoryYahoo[] {
  if (!searchInput || searchInput.length < 1) {
    return [];
  }
  
  // Process input to handle both comma and space separators
  let searchTerms: string[] = [];
  
  // Check if input contains commas
  if (searchInput.includes(',')) {
    // Use comma as separator
    searchTerms = searchInput.toLowerCase().split(',').map(term => term.trim()).filter(Boolean);
  } else {
    // Use space as separator
    searchTerms = searchInput.toLowerCase().split(/\s+/).filter(Boolean);
  }
  
  if (searchTerms.length === 0) return [];
  
  // Get results
  const results = CATEGORIESYAHOO.filter(category => {
    const path = String(category.path || '').toLowerCase();
    const label = String(category.label || '').toLowerCase();
    
    if (searchTerms.length > 1) {
      // AND search - all terms must match
      return searchTerms.every(term => 
        path.includes(term) || label.includes(term)
      );
    } else {
      // Single term search
      const term = searchTerms[0];
      return path.includes(term) || label.includes(term);
    }
  });
  
  // Sort results by total character length (label + path)
  return results
    .sort((a, b) => {
      const aLabel = String(a.label || '');
      const bLabel = String(b.label || '');
      const aPath = String(a.path || '');
      const bPath = String(b.path || '');
      
      // Calculate total length of text
      const aTotalLength = aLabel.length + aPath.length;
      const bTotalLength = bLabel.length + bPath.length;
      
      // Sort by total length (shorter first)
      return aTotalLength - bTotalLength;
    })
    .slice(0, 100); // Limit results for better performance
}

function normalizeCategoryPath(path: string): string {
  return path.trim().replace(/\s*>\s*/g, "/").replace(/\/+/g, "/");
}

function getPathDepth(path: string): number {
  return normalizeCategoryPath(path).split("/").filter(Boolean).length;
}

function pathEndsWithSonota(path: string): boolean {
  const segments = normalizeCategoryPath(path).split("/").filter(Boolean);
  return segments[segments.length - 1] === "その他";
}

/** Prefer safe generic categories; penalize over-specific paths from AI hints. */
function scoreCategoryForAi(category: CategoryYahoo, hint?: string): number {
  const path = normalizeCategoryPath(category.path);
  const segments = path.split("/").filter(Boolean);
  let score = 0;

  if (pathEndsWithSonota(path)) {
    score += 120;
  }

  if (segments.length >= 2) {
    score += 20;
  } else {
    score -= 40;
  }

  if (segments.length > 5) {
    score -= (segments.length - 5) * 25;
  }

  if (hint) {
    const normalizedHint = normalizeCategoryPath(hint);
    if (path === normalizedHint) {
      score += 500;
    } else if (path.startsWith(`${normalizedHint}/`)) {
      score += 80;
      if (pathEndsWithSonota(path)) {
        score += 60;
      }
    } else if (normalizedHint.startsWith(`${path}/`)) {
      score += 40;
    }

    const hintDepth = getPathDepth(normalizedHint);
    const depth = segments.length;
    if (depth > hintDepth) {
      score -= (depth - hintDepth) * 35;
    }
  }

  return score;
}

function pickBestCategory(candidates: CategoryYahoo[], hint?: string): CategoryYahoo | null {
  const unique = new Map<string, CategoryYahoo>();
  for (const candidate of candidates) {
    if (candidate?.path) {
      unique.set(String(candidate.value), candidate);
    }
  }

  const ranked = [...unique.values()].sort(
    (a, b) => scoreCategoryForAi(b, hint) - scoreCategoryForAi(a, hint)
  );

  return ranked[0] ?? null;
}

function collectCandidatesFromHint(hint: string): CategoryYahoo[] {
  const normalizedHint = normalizeCategoryPath(hint);

  const exact = CATEGORIESYAHOO.filter(
    c => normalizeCategoryPath(c.path) === normalizedHint
  );
  if (exact.length > 0) return exact;

  const sonotaUnderHint = CATEGORIESYAHOO.filter(c => {
    const path = normalizeCategoryPath(c.path);
    return path.startsWith(`${normalizedHint}/`) && pathEndsWithSonota(path);
  });
  if (sonotaUnderHint.length > 0) return sonotaUnderHint;

  if (pathEndsWithSonota(normalizedHint)) {
    const parentHint = normalizedHint.split("/").filter(Boolean).slice(0, -1).join("/");
    if (parentHint) {
      const sonotaUnderParent = CATEGORIESYAHOO.filter(c => {
        const path = normalizeCategoryPath(c.path);
        return path.startsWith(`${parentHint}/`) && pathEndsWithSonota(path);
      });
      if (sonotaUnderParent.length > 0) return sonotaUnderParent;
    }
  }

  return [];
}

function collectCandidatesFromKeywords(keywords: string[]): CategoryYahoo[] {
  if (keywords.length === 0) return [];

  const genericQuery = keywords.join(" ");
  const withSonota = searchYahooCategories(`${genericQuery} その他`);
  const base = searchYahooCategories(genericQuery);

  return [...withSonota, ...base];
}

/**
 * Resolve a Yahoo category from AI hints using the same search data as the
 * category dropdown (CATEGORIESYAHOO + searchYahooCategories).
 * Prefers safe, generic paths ending in 「その他」 over specific subcategories.
 */
export function resolveCategoryFromAiHints(
  categoryKeywords: string[],
  categoryPathHint?: string,
  _title?: string
): CategoryYahoo | null {
  const hint = categoryPathHint ? normalizeCategoryPath(categoryPathHint) : undefined;
  const candidates: CategoryYahoo[] = [];

  if (hint) {
    candidates.push(...collectCandidatesFromHint(hint));
  }

  if (categoryKeywords.length > 0) {
    candidates.push(...collectCandidatesFromKeywords(categoryKeywords));
  }

  return pickBestCategory(candidates, hint);
}